import { createSlice } from "@reduxjs/toolkit";


export const tallySyncSlice = createSlice({
    name: 'tallySync',
    initialState: {
        operations: 0,
        tallyReachable: true,
    },
    reducers: {
        increment: state => {
            state.operations += 1
        },
        decrement: state => {
            state.operations -= 1
        },
        reset: state => {
            state.operations = 0
        },
        tallyNotReachable: state => {
            state.tallyReachable = false
        },
        tallyReachable: state => {
            state.tallyReachable = true
        }
    }
})

export default tallySyncSlice.reducer